<template>
    <div>
        <v-snackbar v-model="snackbar1" :timeout="5000" :color="snackbarcolor">
            {{message}}
            <v-btn text @click="closeSnackbar">Close</v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    export default {
        props: ['snackbar','message', 'snackbarcolor'],
        data(){
            return{
            }
        },
        computed: {
            snackbar1: {
                get(){
                    return this.snackbar; 
                },
                set(value) {
                    this.$emit("update:snackbar", value);
               },    
            }
        },
        methods: {
            closeSnackbar(){
                this.$emit('closeSnackbar', false);
            }
        },
        // watch: {
        //     snackbar() {
        //         console.log(this.snackbar)
        //     }
        // },
    }
</script>

<style lang="scss" scoped>

</style>